import { configureStore } from '@reduxjs/toolkit';
import createSagaMiddleware from 'redux-saga';

import { AQA_KEY, DEV_KEY } from 'constants/dev';

import { isProd } from 'helpers/utils';

import rootReducer from './rootReducer';
import rootSaga from './rootSaga';

const sagaMiddleware = createSagaMiddleware();

export const store = configureStore({
    reducer: rootReducer,
    middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware({
            thunk: false,
            serializableCheck: false,
            immutableCheck: false,
        }).concat(sagaMiddleware),
    devTools: !isProd(),
});

sagaMiddleware.run(rootSaga);

const urlParams = new URLSearchParams(window.location.search);
const refParams = urlParams.get(DEV_KEY);

if (refParams === AQA_KEY || localStorage.getItem(DEV_KEY)) {
    localStorage.setItem(DEV_KEY, AQA_KEY);

    (window as any).__getState = () => store.getState();
}

export type Store = ReturnType<typeof rootReducer>;
export type Dispatch = typeof store.dispatch;
